import async from 'async'
import { Taf } from '@huyafed/taf-network'
import { replaceAgreement } from 'amkit3-modules/utils/replaceAgreement'
import {
  // getPlayInfo,
  getBaseInfo,
  getPlayerConfig,
} from 'amkit3-modules/utils/services/huya/v'
import { getAdInfo } from 'amkit3-modules/utils/services/huya/ad'
import { getVideoTranscodeUrlList } from 'amkit3-modules/utils/taf/api/getVideoTranscodeUrlList'
import { getVideoListByVids } from 'amkit3-modules/utils/taf/api/getVideoListByVids'
import { GetMomentBatchByVid } from 'amkit3-modules/utils/taf/api/index'
import { getDigitalDefinition } from 'amkit3-modules/v/player/profile'
// import { getDNSIP } from 'amkit3-modules/utils/huya/dns-for-cdn';

class HuyaPlayerInfo {
  constructor(options) {
    this.vid = options.vid
    this.no_ad = !!options.no_ad
    this.options = options
    this.format = 'mp4,m3u8'
    this.info = { baseInfo: { definitions: [] }, adInfo: [] }
  }
  getUrl(durationUseM3u8, definition) {
    let url = ''
    if (definition.sDuration >= durationUseM3u8) {
      url = definition.sM3u8 || definition.sUrl
    } else {
      url = definition.sUrl || definition.sM3u8
    }
    return url
  }
  getFormat(url) {
    const [src] = url.split('?')
    const index = src.lastIndexOf('.')
    const ext = src.substring(index + 1)
    const format = ext !== 'flv' && ext !== 'mp4' ? 'm3u8' : ext
    return format
  }
  init(cb) {
    // 有直出数据的时候优先
    if (this.options.videoDefinitions && this.options.videoData && this.options.playerConfig) {
      // 先初始化播放器，不阻塞
      this.initData({
        videoDefinitions: this.options.videoDefinitions,
        baseInfo: this.options.videoData,
        playerConfig: this.options.playerConfig,
        cb,
      })

      // 异步获取 momentData，不阻塞播放器初始化
      if (this.options.showVideoExtraInfo) {
        GetMomentBatchByVid([Number(this.vid)])
          .then(momentData => {
            this.updateMomentData(momentData)
          })
          .catch(error => {
            console.warn('GetMomentBatchByVid error:', error)
          })
      }
      return
    }
    async.parallel(
      [
        cb => {
          const vids = new Taf.Vector(new Taf.INT64())
          vids.value.push(Number(this.vid))
          getVideoTranscodeUrlList({
            vids,
          })
            .then(res => {
              const videoMap = res.transcodeInfos.value
              const videoInfo = Object.values(videoMap)[0]
              cb(null, videoInfo)
            })
            .catch(error => {
              cb(error)
            })
        },
        cb => {
          if (this.no_ad) {
            setTimeout(() => cb(null, []), 0)
          } else {
            getAdInfo('', window.location.href, this.vid, '', cb)
          }
        },
        cb => {
          const ids = new Taf.Vector(new Taf.INT64())
          ids.value.push(Number(this.vid))
          getVideoListByVids({
            ids,
          })
            .then(res => {
              const videoData = res.videoPageWrap.videos.value[0]
              cb(null, videoData)
            })
            .catch(error => {
              cb(error)
            })
        },
        // (cb) => getBaseInfo(this.vid, cb),
        cb => getPlayerConfig(cb),
        // 获取 GetMomentBatchByVid 数据
        cb => {
          GetMomentBatchByVid([Number(this.vid)])
            .then(res => {
              cb(null, res)
            })
            .catch(error => {
              console.warn('GetMomentBatchByVid error:', error)
              cb(null, null) // 即使失败也继续，不阻塞其他请求
            })
        },
      ],
      (err, results) => {
        console.log('results', results)
        this.initData({
          videoDefinitions: results[0].videoDefinitions.value,
          baseInfo: results[2],
          playerConfig: results[3],
          momentData: results[4],
          cb,
        })
      },
    )
  }
  initData({ videoDefinitions, baseInfo, playerConfig, momentData, cb }) {
    console.log('momentData', momentData)
    try {
      let adInfo = []
      let labels = {}
      const durationUseM3u8 =
        playerConfig && playerConfig.base ? playerConfig.base.durationUseM3u8 : 0

      // 保存完整的 baseInfo 用于后续获取额外信息
      this.baseInfo = baseInfo

      // 保存 momentData 并提取 AuthorStatementType
      this.momentData = momentData
      this.authorStatementType = ''
      if (momentData && momentData.mCommentInfo && momentData.mCommentInfo.value) {
        const momentInfo = momentData.mCommentInfo.value[this.vid]

        if (momentInfo && momentInfo.mpExtInfo && momentInfo.mpExtInfo.value) {
          this.authorStatementType = momentInfo.mpExtInfo.value.AuthorStatementType || ''
          console.log('momentData', this.authorStatementType)
        }
      }

      this.info = {
        baseInfo: {
          title: baseInfo.videoTitle,
          channel: baseInfo.channelId,
          cover: replaceAgreement(baseInfo.covers.cover),
          definitions: (this.options.definitionConfig || videoDefinitions)
            .reduce((currentArr, item) => {
              const url = replaceAgreement(this.getUrl(durationUseM3u8, item))
              const definition = item.sDefinition
              const format = this.getFormat(url)
              if (!labels[definition]) {
                labels[definition] = true
                const info = {
                  url,
                  format,
                  size: item.sSize,
                  label: item.sDefName,
                  definition: definition,
                  duration: Number(item.sDuration),
                  ts1Offset: item.sTs1Offset || '0@0',
                  ts1Url: item.sTs1Url ? replaceAgreement(item.sTs1Url) : '',
                  lineType: item.iLine,
                  vStreamInfo: (item.streams || item.vStreamInfo).value.map(stream => ({
                    ...stream,
                    sCodec: stream.codec,
                    mpExtraParam: stream.extParam,
                    iBitRate: stream.iBitrate,
                    sM3u8: replaceAgreement(stream.sM3u8),
                    sTs1Url: replaceAgreement(stream.sTs1Url),
                    sUrl: replaceAgreement(stream.sUrl),
                  })),
                }
                currentArr.push(info)
              }
              return currentArr
            }, [])
            .sort((prev, next) => {
              const prevDigitalDefinition = getDigitalDefinition(prev.definition)
              const nextDigitalDefinition = getDigitalDefinition(next.definition)
              return nextDigitalDefinition - prevDigitalDefinition
            }),
        },
        adInfo: adInfo.map(item => {
          return {
            adLocation: item.adLocation,
            ati: item.ati,
            adId: item.adid,
            clickUrl: item.clickUrl,
            code: item.code,
            fodderUrl: item.fodderUrl,
            // TODO
            // fodderUrl: 'http://172.28.19.19/b38c287cb6724de9cded2cbdcedf0a94.mp4',
            // fodderUrl: 'http://172.28.19.19/test.mp4',
            height: item.height,
            width: item.width,
            videoTime: item.videoTime,
          }
        }),
      }
      // default
      this.playerConfig = playerConfig || undefined
      console.log('this.playerConfig', playerConfig)
      cb(null)
    } catch (error) {
      console.log('error', error)
      return cb(error)
    }
  }
  setDefinition(definition) {
    const { definitions } = this.info.baseInfo
    //优先拿匹配的
    let definitionConfig = definitions.find(item => item.definition === definition)
    if (!definitionConfig) {
      //其次拿第一个小于目标清晰度的
      definitionConfig = definitions.find(item => {
        const currentDigitalDefinition = getDigitalDefinition(item.definition)
        const targetDefinition = getDigitalDefinition(definition)
        return Number(currentDigitalDefinition) < Number(targetDefinition)
      })
      if (!definitionConfig) {
        //最后拿最接近的
        const definitionMap = definitions.reduce((currentMap, item) => {
          const currentDigitalDefinition = getDigitalDefinition(item.definition)
          const targetDefinition = getDigitalDefinition(definition)
          currentMap[Math.abs(targetDefinition - currentDigitalDefinition)] = item
          return currentMap
        }, {})
        const min = Math.min(...Object.keys(definitionMap))
        definitionConfig = definitionMap[min]
      }
    }
    this.definitionConfig = definitionConfig
    return definitionConfig
  }
  getDefinitionConfig() {
    return this.definitionConfig
  }
  getDefinitions() {
    return this.info.baseInfo.definitions
  }
  getCover() {
    return replaceAgreement(this.info.baseInfo.cover)
    // return this.info.baseInfo.cover
  }
  getAds() {
    return this.info.adInfo
  }
  // statistic
  getVid() {
    return this.vid
  }
  getChannelId() {
    return this.info.baseInfo.channel
  }
  getVname() {
    return this.info.baseInfo.title
  }

  // statistic cdn
  getCDN() {
    if (this.definitionConfig) {
      let url = this.definitionConfig.url
      return url.match(/\/\/(.+).huya.com/) ? url.match(/\/\/(.+).huya.com/)[1] || '' : ''
    } else {
      return ''
    }
  }
  getCDNURL() {
    if (this.definitionConfig) return this.definitionConfig.url
    else return ''
  }

  // 获取视频额外信息（从 getVideoListByVids 接口返回的数据）
  getExtraInfo(fieldName) {
    if (!this.baseInfo) return ''
    return this.baseInfo[fieldName] || ''
  }

  // 获取完整的 baseInfo 对象
  getBaseInfo() {
    return this.baseInfo || {}
  }

  // 获取 AuthorStatementType 信息
  getAuthorStatementType() {
    return this.authorStatementType || ''
  }

  // 更新 momentData（用于直出场景的异步更新）
  updateMomentData(momentData) {
    this.momentData = momentData
    this.authorStatementType = ''

    if (momentData && momentData.mCommentInfo && momentData.mCommentInfo.value) {
      const momentInfo = momentData.mCommentInfo.value[this.vid]

      if (momentInfo && momentInfo.mpExtInfo && momentInfo.mpExtInfo.value) {
        this.authorStatementType = momentInfo.mpExtInfo.value.AuthorStatementType || ''
      }
    }

    // 触发回调通知 UI 更新
    if (this.onMomentDataUpdate && this.authorStatementType) {
      this.onMomentDataUpdate(this.authorStatementType)
    }
  }

  // 设置 momentData 更新回调
  setMomentDataUpdateCallback(callback) {
    this.onMomentDataUpdate = callback
  }
}

export default HuyaPlayerInfo
